<div>
  <input [(ngModel)]="datasourceDelay" style="width: 50px" /> -
  <small>datasource delay</small>
  <br />
  <input [(ngModel)]="reloadIndex" style="width: 50px" /> -
  <small>reload index</small>
  <br />
  <button (click)="doHideShow()">
    <span *ngIf="show">Destroy</span>
    <span *ngIf="!show">Create</span>
  </button>
  <button (click)="doReload()">Reload</button>
  <br />
  <div *ngIf="show">
    <button (click)="doPrepend()">Prepend</button>
    <button (click)="doNG0956()">
      {{ reproModeNG0956 ? 'NG0956 Off' : 'NG0956' }}
    </button>
    <button (click)="doLog()">Show log</button>
    <br />
    <button (click)="doScrollHome()">Up</button>
    <button (click)="doScrollEnd()">Down</button>
    <button (click)="doScrollSome()">Some</button>
    <br />
    <input [(ngModel)]="sizeIndex" style="width: 50px" />
    <button (click)="doChangeSize()">Size</button>
    <br />
    <small
      >ngx-ui-scroll version:
      {{ datasource.adapter.packageInfo.consumer.version }}</small
    >
    <br />
    <small
      >isLoading:
      {{ datasource.adapter.isLoading$ | async }}
    </small>
    <br />
    <small
      >first visible:
      {{ (datasource.adapter.firstVisible$ | async)?.$index }}
    </small>
    <br />
    <small
      >last visible:
      {{ (datasource.adapter.lastVisible$ | async)?.$index }}
    </small>
    <br />
    <small
      >total: {{ itemsCount() }}, visible:
      {{ getVisibleItemsCount() }}
    </small>
  </div>
  <br /><br />
</div>
<div class="viewport" #viewport style="height: 600px" id="my-viewport">
  <div *ngIf="show">
    <div
      *uiScroll="let item of datasource"
      (click)="doToggleItem(item)"
      [style.height]="item.size + 'px'"
    >
      <app-samples-test-inner>
        {{ item.text }}
        <span [style.color]="item.color">
          {{ item.isSelected ? '********' : '' }}
        </span>
      </app-samples-test-inner>
    </div>
  </div>
</div>
